import CodeBlock from "../../../../src/components/codeBlock.tsx";
import RandomWalk from "../../../../content/map-accum/randomWalk.tsx";
import * as React from 'react';
export default {
  CodeBlock,
  RandomWalk,
  React
};